import * as React from 'react';
import SiteFooter from './site_footer';
import SiteSubFooter from './site_subfooter';

export default function () {
  return (
    <>
      <SiteFooter />
      <SiteSubFooter />
    </>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/site_footer_container.tsx